import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Typography,
    Box,
    Divider,
    TextField,
    InputAdornment
} from "@mui/material";
import { useTemplateFontSettings } from "styles/templateFontSettings";
import { useSelector } from "react-redux";
import { getLocaleDateWithTimeCustomV2 } from "app/utils/appHelpers";
import SearchIcon from '@mui/icons-material/Search';

function AgendaTemplateSelectionDialog({
    onClose,
    open,
    onTemplateSelect,
    templateType = 'agenda' // 'agenda' or 'decision'
}) {
    const { titleSize, lineHeight } = useTemplateFontSettings();
    const { authUser } = useSelector(state => state.auth);
    const allAgendaTemplates = useSelector(state => state.general.agendaTemplates);

    const [searchText, setSearchText] = useState("");
    const [filteredTemplates, setFilteredTemplates] = useState([]);

    // Filter templates by current user and search text
    useEffect(() => {
        let filtered = allAgendaTemplates.filter(template =>
            template.userId === authUser.id
        );

        if (searchText.trim() !== "") {
            filtered = filtered.filter(template =>
                template.title.toLowerCase().includes(searchText.toLowerCase()) ||
                template.body.toLowerCase().includes(searchText.toLowerCase())
            );
        }

        setFilteredTemplates(filtered);
    }, [allAgendaTemplates, authUser.id, searchText]);

    const handleTemplateSelect = (template) => {
        onTemplateSelect(template.body);
        onClose();
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
            <DialogTitle style={{ fontSize: titleSize, lineHeight: lineHeight }}>
                {templateType === 'agenda' ? 'Gündem Şablonu Seç' : 'Karar Şablonu Seç'}
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ mb: 2 }}>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Şablon ara..."
                        value={searchText}
                        onChange={handleSearchChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {filteredTemplates.length === 0 ? (
                    <Box sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant="body1" color="textSecondary">
                            {searchText.trim() !== ""
                                ? "Arama kriterlerine uygun şablon bulunamadı."
                                : "Henüz şablon oluşturmadınız."}
                        </Typography>
                    </Box>
                ) : (
                    <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {filteredTemplates.map((template, index) => (
                            <React.Fragment key={template.id}>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={() => handleTemplateSelect(template)}>
                                        <ListItemText
                                            primary={
                                                <Typography variant="subtitle1" fontWeight="medium">
                                                    {template.title}
                                                </Typography>
                                            }
                                            secondary={
                                                <Box>
                                                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                                        {template.body.length > 150
                                                            ? template.body.substring(0, 150) + '...'
                                                            : template.body}
                                                    </Typography>
                                                    <Typography variant="caption" color="textSecondary">
                                                        Güncelleme: {getLocaleDateWithTimeCustomV2("tr", template.pdate)}
                                                    </Typography>
                                                </Box>
                                            }
                                        />
                                    </ListItemButton>
                                </ListItem>
                                {index < filteredTemplates.length - 1 && <Divider />}
                            </React.Fragment>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={onClose}>
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AgendaTemplateSelectionDialog; 